import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class XenioUpdatesService {

    static getAllCompanyVersions(page, maxPerPage,CompanyCode, email) {
  
        return axios.get(`${BaseUrl}DeviceUpdate?page=${page}&maxPerPage=${maxPerPage}&CompanyCode=${CompanyCode ? CompanyCode : ''}&email=${email ? email : ''}`);
    }

    static getAllUpdateType(CompanyCode) {
  
        return axios.get(`${BaseUrl}UpdateType?CompanyCode=${CompanyCode ? CompanyCode : ''}`);
    }

    static getAllUpdateVersion(CompanyCode, UpdateID) {
  
        return axios.get(`${BaseUrl}UpdateVersion?CompanyCode=${CompanyCode ? CompanyCode : ''}&UpdateID=${UpdateID}`);
    }

    static AddCompanyVersion(CompanyCode, UpdateVersion, TypeID, email) {
        var data = {
            UpdateVersionId: UpdateVersion,
            CompanyCode:CompanyCode,
            TypeID: TypeID
        };
  
        return axios.post( BaseUrl + 'DeviceUpdate?email='+email, data);
    }

    static DeleteDeviceUpdate(id, CompanyCode, email) {
        //var id = serialNumber;
        return axios.delete(`${BaseUrl}DeviceUpdate?ID=${id}&CompanyCode=${CompanyCode ? CompanyCode : ''}&email=${email}`);
    }

    //Versions
    static getAllVersions(page, maxPerPage,VersionName, UpdateID) {
  
        return axios.get(`${BaseUrl}Version?page=${page}&maxPerPage=${maxPerPage}&VersionName=${VersionName}&UpdateID=${UpdateID}`);
    }

    static getAllUpdates() {
  
        return axios.get(`${BaseUrl}Update`);
    }


    static AddVersion(VersionName, UpdateID, Description, FileName, DataFile, email) {

        var data = {
            VersionName: VersionName,
            UpdateID:UpdateID,
            Description: Description,
            FileName: FileName,
            fileData: DataFile,
            email: email
        };
        //const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        //console.log(data)

        return axios.post( BaseUrl + 'Version?email='+email, data);
    }

    static EditVersion(ID, VersionName, UpdateID, Description, FileName, DataFile, email) {
        var data = {
            ID:ID,
            VersionName: VersionName,
            UpdateID:UpdateID,
            Description: Description,
            FileName:FileName,
            fileData: DataFile,
            email: email
        };
        return axios.put(BaseUrl+ 'Version?email='+ email, data);
    }

    static DeleteUpdate(id, email) {
        //var id = serialNumber;
        return axios.delete(`${BaseUrl}Version?ID=${id}&email=${email}`);
    }

}


// WEBPACK FOOTER //
// ./src/Services/XenioUpdates/xenioUpdates.js